module.exports = __webpack_public_path__ + "media/images/covers/Tamara-Consultations-Banner_mobile-d7924185b0361f494701ede45990d7c6.jpg";